import React from 'react';

import Switch, { type SwitchProps } from '@mui/material/Switch';

import { withStyles } from 'makeStyles';

const Component = ({ classes, ...props }: SwitchProps) => {
  return (
    <Switch
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
};

export const TMXSwitch = withStyles(Component, (theme: any, props, classes: any) => ({
  root: {
    width: 50,
    height: 28,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    left: 1,
    [`&.${classes.checked}`]: {
      transform: 'translateX(22px)',
      color: theme.palette.common.white,
      [`& + .${classes.track}`]: {
        backgroundColor: theme.palette.primary.main,
        opacity: 1,
        border: 'none',
      },
    },
  },
  thumb: {
    width: 24,
    height: 24,
    marginTop: 1,
    color: theme.palette.common.white,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[300]}`,
    backgroundColor: theme.palette.grey[300],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
}));
